import React, { useEffect, useContext } from 'react';
import {
  genericVerifyDoc,
  genericRejectDoc
} from '../../../common/constants/api';
import CommonBtn from '../../../containers/LeadProfile/CommonBtn/CommonBtn';
import { getApplicantionInfo } from '../../../common/utils/applicantionInfo';
import { ReadOnly } from '../../../containers/CMDashboard/CMDetailView';

export const verificationHandler = (
  docId,
  setVerifiedStatus,
  setPopShow,
  setError
) => {
  genericVerifyDoc(getApplicantionInfo().leadId, docId)
    .then(res => {
      setVerifiedStatus(true);
    })
    .catch(err => {
      setError(
        err?.response?.data?.message ||
          'something went wrong! Please try again..'
      );
      setPopShow(true);
    });
};
export const rejectHandler = (
  docId,
  setVerifiedStatus,
  setPopShow,
  setError
) => {
  genericRejectDoc(getApplicantionInfo().leadId, docId, 'Incorrect Document')
    .then(res => {
      setVerifiedStatus(false);
    })
    .catch(err => {
      setError(
        err?.response?.data?.message ||
          'something went wrong! Please try again..'
      );
      setPopShow(true);
    });
};

export const showVerificationStatus = (
  verificationStatus,
  docId,
  setVerifiedStatus,
  setPopShow,
  setError
) => {
  const isReadOnly = useContext(ReadOnly);

  useEffect(() => {
    return () => {
      setPopShow(false);
      setError(false);
    };
  }, []);

  if (verificationStatus) {
    return (
      <div className="flex items-center mb-4">
        <span className="text-green-paleGreen bg-green-thinGreen font-roboto font-normal px-2 text-xs  items-center rounded ">
          Verified
        </span>
        {!isReadOnly ? (
          <span
            onClick={() => {
              setVerifiedStatus(null);
            }}
            className="text-orange-1100 font-roboto font-norma ml-1 items-center text-xs cursor-pointer"
          >
            Undo
          </span>
        ) : null}
      </div>
    );
  }

  if (verificationStatus === false)
    return (
      <div className="flex items-center mb-4">
        <span className="text-red-200 bg-red-600 font-roboto font-normal px-2 text-xs  items-center rounded ">
          Not Verified
        </span>
        {!isReadOnly ? (
          <span
            onClick={() => {
              setVerifiedStatus(null);
            }}
            className="text-orange-1100 font-roboto font-norma ml-1 items-center text-xs cursor-pointer"
          >
            Undo
          </span>
        ) : null}
      </div>
    );

  if (verificationStatus === null && !isReadOnly)
    return (
      <div
        className={` flex  order-1 xxl:order-none ml-auto`}
        style={{ width: 'fit-content' }}
      >
        <CommonBtn
          value="Not Verified"
          stylesBtn={{
            backgroundColor: 'white',
            color: '#FD4F60',
            padding: '14px',
            borderColor: '#FD4F60',
            border: '1px solid',
            width: '7rem',
            textAlign: 'center',
            display: 'block'
          }}
          onClick={() => {
            rejectHandler(docId, setVerifiedStatus, setPopShow, setError);
          }}
        />
        <CommonBtn
          value="Verified"
          stylesBtn={{
            backgroundColor: 'white',
            color: '#00ACB8',
            borderColor: '#00ACB8',
            padding: '14px',
            border: '1px solid',
            width: '7rem',
            textAlign: 'center',
            display: 'block'
          }}
          onClick={() => {
            verificationHandler(docId, setVerifiedStatus, setPopShow, setError);
          }}
        />
      </div>
    );
};
